import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@wundo/ui';
import { m } from '@/paraglide/messages.js';

export interface PracticeWrapUpDialogProps {
  /** Held while the feedback is being written, so it cannot be asked for twice. */
  ending: boolean;
  onEnd: () => void;
  onKeepGoing: () => void;
}

/**
 * Ten minutes in: is this conversation done?
 *
 * A practice conversation has no natural end — the character will keep talking
 * for as long as somebody talks back — and the feedback is written from the
 * whole of it, so one that runs on gets a debrief about half an hour of
 * wandering. Asked once, and never again: a second nudge would be nagging, and
 * the character asks in its own words when it thinks the same thing.
 */
export function PracticeWrapUpDialog({
  ending,
  onEnd,
  onKeepGoing,
}: PracticeWrapUpDialogProps) {
  return (
    <Dialog open onOpenChange={(next) => !next && onKeepGoing()}>
      <DialogContent size='md'>
        <DialogHeader>
          <DialogTitle>{m.practice_session_ten_minutes()}</DialogTitle>
        </DialogHeader>

        <div className='px-5 pt-4 pb-1'>
          <DialogDescription className='text-base text-ink-body'>
            {m.practice_session_ten_minutes_body()}
          </DialogDescription>
        </div>

        <DialogFooter>
          <Button variant='quiet' onClick={onKeepGoing}>
            {m.practice_session_keep_going()}
          </Button>
          <Button disabled={ending} onClick={onEnd}>
            {m.practice_session_end()}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
